export default function generateBorderClipPath(
  borderType: number,
  borderSize: number
) {
  if (borderType === 1)
    return `polygon(0% 0%, 100% 0%, 100% calc(100% - ${borderSize}px), 0% 100%`
  if (borderType === 2)
    return `polygon(0% 0%, 100% 0%, 100% 100%, 0% calc(100% - ${borderSize}px)`
}
